import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {SalesClientIdentificationComponent} from "./sales-client-identification.component";
import {SalesClientIdentificationKredicashComponent} from "./kredicash/sales-client-identification-kredicash.component";
import {SalesClientIdentificationGeneralComponent} from "./general/sales-client-identification-general.component";
import {PrimengModule} from "../../shared/primeng-module/primeng.module";
import {LibraryModule} from "library";
import {ReactiveFormsModule} from "@angular/forms";
import {GeneralModule} from "../general/general.module";



@NgModule({
  declarations: [
    SalesClientIdentificationComponent,
    SalesClientIdentificationKredicashComponent,
    SalesClientIdentificationGeneralComponent
  ],
    imports: [
        CommonModule,
        PrimengModule,
        LibraryModule,
        ReactiveFormsModule,
    GeneralModule

    ],
  exports: [
    SalesClientIdentificationComponent
  ]
})
export class SalesClientIdentificationModule { }
